import { getRouteUrl as getURL } from '@nackle/service-urls';

let env = window.location.hostname.toLowerCase().split( '.' ).find( function ( chunk ) {
    console.log( chunk );
    return [ 'localhost', 'ngrok-free', 'qa', 'pprd' ].indexOf( chunk ) >= 0;
} );

if ( env === 'localhost' || env === 'ngrok-free' ) {
    env = 'qa';
}

export const currentEnv = env;

export const idURL = getURL( 'ID_PROVIDER' );
export const privacyUrl = `${ getURL( 'PRIVACY_API' ) }/services/v1`;
export const privacyDownloadUrl = getURL( 'PRIVACY_API' );
export const solutionsUrl = `${ getURL( 'SOLUTION_API' ) }/services/v1`;
export const companyUrl = getURL( 'COMPANY_SERVICE' );

